import React, { FC } from 'react';
import { AxiosError } from 'axios';
import Modal from '@common/modal';
import { useToast } from '@common/toast';
import { useDeleteResume } from '@repository/match';
import { PositionApplyCancelErrorCode } from '@domain/rs/position/jd/PositionAppyRs';

import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ResumeDeleteModalProps {
  positionSn: number;
  visible: boolean;
  onClose: () => void;
  confirmAfter?: () => void;
}

const ResumeDeleteModal: FC<ResumeDeleteModalProps> = ({ positionSn, visible, onClose, confirmAfter }) => {
  const Toast = useToast();

  const handleDeleteResumeError = (code: PositionApplyCancelErrorCode) => {
    let content: string;
    switch (code) {
      case 'B901':
        content = '삭제된 포지션입니다.';
        break;
      case 'B902':
        content = '이미 삭제된 지원서입니다.';
        break;
      case 'B903':
        content = '이미 제출된 지원서입니다.';
        break;
      case 'B908':
      default:
        //ATS 서버와 통신에 실패했습니다.
        content = 'ATS 서버와 통신에 실패했습니다.';
    }
    Toast({
      type: 'error',
      iconType: 'info',
      content,
    });
    onClose();
  };

  const { mutate: fetchDeleteResume } = useDeleteResume(
    async () => {
      Toast({
        type: 'success',
        iconType: 'info',
        content: '지원서 삭제를 성공했습니다.',
      });
      //지원 현황 재조회
      await confirmAfter?.();
      onClose();
    },
    (e: AxiosError) => handleDeleteResumeError(e?.response?.data.errorCode),
  );
  const onClickDeleteCheck = () => {
    fetchDeleteResume(positionSn);
  };

  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>지원서를 삭제하시겠어요?</em>
        <p className={cx('desc')}>삭제한 지원서는 다시 되돌릴 수 없습니다.</p>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'cancel')} onClick={onClose}>
            취소
          </button>
          <button className={cx('btn', 'check')} onClick={onClickDeleteCheck}>
            삭제
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ResumeDeleteModal;
